<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="map_options">
  @if (isTracking === true) {
    <ul class="toptop" style="cursor: pointer">
      <li (click)="btn_sos(sos())">
        <figure><img [src]="assetsConst.sos" alt="globe" /></figure>
      </li>
      @if (sos() === true) {
        @if (
          (user && user.default_region.admin_phone !== '') ||
          (shareType != null && supportPhone() !== '')
        ) {
          <a
            [href]="
              'tel:' +
              (supportPhone() || user?.default_region.admin_phone || '')
            ">
            <li>
              <figure><img [src]="assetsConst.callSP" alt="globe" /></figure>
            </li>
          </a>
        }
      }
    </ul>
  }
  @if (showWidgetPickUp() === true) {
    <ul class="top" style="cursor: pointer">
      <li (click)="setSatellite()">
        <figure>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect
              width="40"
              height="40"
              rx="20"
              fill="white"
              fill-opacity="0.7" />
            <g clip-path="url(#clip0_4883_14828)">
              <path
                d="M20.5 9C14.703 9 10 13.7419 10 19.5C10 25.2815 14.7188 30 20.5 30C26.2816 30 31 25.2812 31 19.5C31 13.7184 26.2812 9 20.5 9ZM20.5 10.2305C21.5241 10.2305 22.5098 10.3978 23.4316 10.7058C23.2588 10.961 23.1508 11.2983 23.1508 11.7335C23.1508 12.3981 23.4478 12.9921 23.735 13.5666C23.9687 14.034 24.1894 14.4754 24.1894 14.8495C24.1894 15.0658 24.1379 15.1156 23.9609 15.1747C23.6231 15.2873 22.9958 15.274 22.5663 15.2726C21.5525 15.2692 20.4027 15.2655 19.1763 16.4918C19.007 16.6612 18.9153 16.6698 18.3286 16.3765C17.7918 16.1081 16.8933 15.6589 16.0605 16.4918C15.5733 16.9789 15.3809 17.6649 15.5156 18.3607C14.9136 18.127 14.0812 18.0188 13.9794 17.7604C13.9323 17.641 13.8587 17.1209 14.8902 15.4462C15.2728 14.8251 15.7323 13.9151 15.3083 13.1861C15.1027 12.8326 14.7581 12.6444 14.3777 12.5463C16.0118 11.1059 18.1555 10.2305 20.5 10.2305ZM20.5 28.7695C15.3888 28.7695 11.2305 24.6112 11.2305 19.5C11.2305 17.2971 12.0034 15.2717 13.2915 13.6794C14.0006 13.6734 14.1921 13.7596 14.2434 13.8055C14.2499 13.8458 14.2687 14.1091 13.8425 14.8009C12.837 16.4334 12.5356 17.4535 12.8347 18.2119C13.2387 19.2364 14.5069 19.2379 15.1954 19.5611C15.612 19.7566 17.7145 20.7251 17.9575 21.086V22.1201C17.9575 22.891 18.6854 23.3073 19.2702 23.6419C19.5072 23.7774 20.0002 24.0595 20.0348 24.1974C20.0348 26.6517 20.2711 28.0028 20.5756 28.7686C20.5504 28.7688 20.5253 28.7695 20.5 28.7695ZM22.1004 28.1043C22.1043 28.2281 21.975 28.4802 21.8634 28.5929C21.7065 28.3752 21.2653 27.4717 21.2653 24.1974C21.2653 23.3655 20.4979 22.9265 19.8812 22.5738C19.6642 22.4496 19.2619 22.2219 19.1839 22.0963V21.0814C19.1839 20.9157 19.1572 20.7678 19.104 20.6348C20.1265 20.5409 20.6246 20.1807 21.0024 19.9075C21.2676 19.7157 21.4007 19.6194 21.6887 19.6194C21.697 19.6194 21.7012 19.62 21.7011 19.6199C21.7658 19.6516 21.9033 19.8814 21.9856 20.0189C22.6832 21.1846 23.3638 21.6012 24.698 21.8934C24.8769 21.9326 25.1429 21.9909 25.2218 22.0434C25.2245 22.056 25.2281 22.0802 25.2281 22.12C25.2281 23.3896 24.2508 24.3094 23.3886 25.1209C22.6972 25.7716 22.1001 26.3336 22.1001 27.0467C22.1001 27.1463 22.0988 28.05 22.1004 28.1043ZM23.3121 28.333C23.3261 28.244 23.3286 28.1561 23.3263 28.0712C23.3254 27.9879 23.3265 27.0529 23.3265 27.0468C23.3266 27.046 23.3358 26.9572 23.5224 26.7314C23.696 26.5213 23.9563 26.2763 24.232 26.0168C25.1716 25.1324 26.4585 23.9212 26.4585 22.12C26.4585 21.5032 26.1474 21.1751 25.8865 21.0084C25.6136 20.8342 25.2968 20.7648 24.9613 20.6913C23.9648 20.4731 23.5634 20.2594 23.0415 19.3872C22.7895 18.9658 22.4443 18.3888 21.6887 18.3888C21.0025 18.3888 20.6026 18.6779 20.2813 18.9102C19.9136 19.1762 19.5661 19.4274 18.5728 19.4274C17.5862 19.4274 16.9993 18.8557 16.7965 18.3662C16.7198 18.1811 16.5794 17.7128 16.9305 17.3617C17.1 17.1923 17.1916 17.1836 17.7783 17.477C18.3151 17.7454 19.2136 18.1946 20.0464 17.3617C20.9107 16.4975 21.6397 16.4999 22.5623 16.5029C23.1527 16.5048 23.8248 16.517 24.3501 16.3418C25.0399 16.1119 25.4199 15.5818 25.4199 14.8494C25.4199 14.1848 25.1229 13.5908 24.8356 13.0163C24.602 12.5489 24.3813 12.1075 24.3813 11.7334C24.3813 11.4447 24.444 11.2832 24.7624 11.2703C27.7346 12.8161 29.7695 15.9247 29.7695 19.5C29.7695 23.6313 27.0527 27.1394 23.3121 28.333Z"
                [attr.fill]="getFillColorSatellite()" />
            </g>
            <defs>
              <clipPath id="clip0_4883_14828">
                <rect
                  width="21"
                  height="21"
                  fill="white"
                  transform="translate(10 9)" />
              </clipPath>
            </defs>
          </svg>
        </figure>
      </li>
      <li (click)="setTraffic()">
        <figure>
          <svg
            width="16"
            height="22"
            viewBox="0 0 16 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2.98291 0.28125H13.0155V21.2645H2.98291V0.28125Z"
              [attr.fill]="getFillColor()" />
            <path
              d="M2.98291 0.28125H13.0155V1.03534H2.98291V0.28125Z"
              [attr.fill]="getFillColor()" />
            <path
              d="M7.99945 7.0028C9.46615 7.0028 10.6551 5.81381 10.6551 4.3471C10.6551 2.8804 9.46615 1.69141 7.99945 1.69141C6.53275 1.69141 5.34375 2.8804 5.34375 4.3471C5.34375 5.81381 6.53275 7.0028 7.99945 7.0028Z"
              fill="white" />
            <path
              d="M7.99945 13.4286C9.46615 13.4286 10.6551 12.2396 10.6551 10.7729C10.6551 9.30618 9.46615 8.11719 7.99945 8.11719C6.53275 8.11719 5.34375 9.30618 5.34375 10.7729C5.34375 12.2396 6.53275 13.4286 7.99945 13.4286Z"
              fill="white" />
            <path
              d="M7.99945 19.8544C9.46615 19.8544 10.6551 18.6654 10.6551 17.1987C10.6551 15.732 9.46615 14.543 7.99945 14.543C6.53275 14.543 5.34375 15.732 5.34375 17.1987C5.34375 18.6654 6.53275 19.8544 7.99945 19.8544Z"
              fill="white" />
            <path
              d="M2.98307 7.0028H2.13063L-0.000488281 1.69141H2.98307V7.0028Z"
              [attr.fill]="getFillColor()" />
            <path
              d="M2.98307 13.4286H2.13063L-0.000488281 8.11719H2.98307V13.4286Z"
              [attr.fill]="getFillColor()" />
            <path
              d="M2.98307 19.8553H2.13063L-0.000488281 14.5439H2.98307V19.8553Z"
              [attr.fill]="getFillColor()" />
            <path
              d="M13.0156 7.0028H13.8681L15.9992 1.69141H13.0156V7.0028Z"
              [attr.fill]="getFillColor()" />
            <path
              d="M13.0156 13.4286H13.8681L15.9992 8.11719H13.0156V13.4286Z"
              [attr.fill]="getFillColor()" />
            <path
              d="M13.0156 19.8553H13.8681L15.9992 14.5439H13.0156V19.8553Z"
              [attr.fill]="getFillColor()" />
            <path
              d="M2.98307 2.77336V1.69141H-0.000488281L0.458521 2.77336H2.98307Z"
              [attr.fill]="getFillColor()" />
            <path
              d="M15.5402 2.77336L15.9992 1.69141H13.0156V2.77336H15.5402Z"
              [attr.fill]="getFillColor()" />
            <path
              d="M2.98307 9.19914V8.11719H-0.000488281L0.458521 9.19914H2.98307Z"
              [attr.fill]="getFillColor()" />
            <path
              d="M15.5402 9.19914L15.9992 8.11719H13.0156V9.19914H15.5402Z"
              [attr.fill]="getFillColor()" />
            <path
              d="M2.98307 15.6577V14.543H-0.000488281L0.458521 15.6577H2.98307Z"
              [attr.fill]="getFillColor()" />
            <path
              d="M15.5402 15.6577L15.9992 14.543H13.0156V15.6577H15.5402Z"
              [attr.fill]="getFillColor()" />
          </svg>
        </figure>
      </li>
      <li (click)="setLocation()">
        <figure>
          <svg
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.5 0.30957C11.1213 0.30957 11.625 0.81325 11.625 1.43457V3.30957C11.625 3.93089 11.1213 4.43457 10.5 4.43457C9.87868 4.43457 9.375 3.93089 9.375 3.30957V1.43457C9.375 0.81325 9.87868 0.30957 10.5 0.30957Z"
              [attr.fill]="getFillColorLocation()" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.5 17.1846C11.1213 17.1846 11.625 17.6882 11.625 18.3096V20.1846C11.625 20.8059 11.1213 21.3096 10.5 21.3096C9.87868 21.3096 9.375 20.8059 9.375 20.1846V18.3096C9.375 17.6882 9.87868 17.1846 10.5 17.1846Z"
              [attr.fill]="getFillColorLocation()" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.12489 4.26175C7.41992 3.39643 8.94248 2.93457 10.5 2.93457C12.5886 2.93457 14.5916 3.76426 16.0685 5.2411C17.5453 6.71795 18.375 8.72099 18.375 10.8096C18.375 12.3671 17.9131 13.8896 17.0478 15.1847C16.1825 16.4797 14.9526 17.4891 13.5136 18.0851C12.0747 18.6812 10.4913 18.8371 8.96367 18.5333C7.43607 18.2294 6.03288 17.4794 4.93154 16.378C3.8302 15.2767 3.08018 13.8735 2.77632 12.3459C2.47246 10.8183 2.62841 9.23491 3.22445 7.79594C3.82049 6.35697 4.82985 5.12706 6.12489 4.26175ZM10.5 5.18457C9.38748 5.18457 8.29995 5.51447 7.37492 6.13255C6.44989 6.75064 5.72892 7.62914 5.30318 8.65698C4.87744 9.68481 4.76604 10.8158 4.98309 11.907C5.20013 12.9981 5.73586 14.0004 6.52253 14.787C7.3092 15.5737 8.31148 16.1094 9.40262 16.3265C10.4938 16.5435 11.6248 16.4321 12.6526 16.0064C13.6804 15.5807 14.5589 14.8597 15.177 13.9347C15.7951 13.0096 16.125 11.9221 16.125 10.8096C16.125 9.31773 15.5324 7.88699 14.4775 6.83209C13.4226 5.7772 11.9918 5.18457 10.5 5.18457Z"
              [attr.fill]="getFillColorLocation()" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.875 10.8096C16.875 10.1882 17.3787 9.68457 18 9.68457H19.875C20.4963 9.68457 21 10.1882 21 10.8096C21 11.4309 20.4963 11.9346 19.875 11.9346H18C17.3787 11.9346 16.875 11.4309 16.875 10.8096Z"
              [attr.fill]="getFillColorLocation()" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 10.8096C0 10.1882 0.50368 9.68457 1.125 9.68457H3C3.62132 9.68457 4.125 10.1882 4.125 10.8096C4.125 11.4309 3.62132 11.9346 3 11.9346H1.125C0.50368 11.9346 0 11.4309 0 10.8096Z"
              [attr.fill]="getFillColorLocation()" />
            <circle
              cx="10.5"
              cy="10.8096"
              r="3.5"
              [attr.fill]="getFillColorLocation()" />
          </svg>
        </figure>
      </li>
    </ul>
  }
  @if (accessToken()) {
    <ul class="bottom bg_primary">
      <li (click)="openAI()" class="cursor-pointer">
        <figure><img [src]="assetsConst.voicenote" alt="voicenote" /></figure>
      </li>
    </ul>
  }
</div>
